import React from 'react'
import type { Icon } from 'shared/utils'

const Hexagon = (props: Icon) => {
    const { color = 'black', size = 24, className = 'blazon-icon' } = props
    return (
        <svg className={className} width={size} height={size}>
            <path
                fill={color}
                fillRule="evenodd"
                d="M13.514 2.336l6.5 3.824A2 2 0 0 1 21 7.884v7.712a2 2 0 0 1-.986 1.724l-6.5 3.823a2 2 0 0 1-2.028 0l-6.5-3.823A2 2 0 0 1 4 15.596V7.884a2 2 0 0 1 .986-1.724l6.5-3.824a2 2 0 0 1 2.028 0z"
            />
        </svg>
    )
}

export { Hexagon }
